import { render } from "./Activities.vue?vue&type=template&id=4787a883&scoped=true"
import script from "./Activities.vue?vue&type=script&lang=js"
export * from "./Activities.vue?vue&type=script&lang=js"

import "./Activities.vue?vue&type=style&index=0&id=4787a883&lang=scss&scoped=true"

import exportComponent from "/home/forge/hr.tomorrow.services/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4787a883"]])

export default __exports__